module.exports = __webpack_public_path__ + "img/playbutton2.1ef45e9b.png";